import { createLinkMatcherWithRegExp, AutoLinkPlugin } from "@lexical/react/LexicalAutoLinkPlugin";
import React__default from "react";
const URL_REGEX = /(?:(?:https?|ftp):\/\/)?(?:[\w-]+(?::[\w-]+)?@)?(?:(?:[\w-]+(?:\.[\w-]+)*(?:\.[a-zA-Z]{2,}))|(?:(?:[0-9]{1,3}\.){3}[0-9]{1,3}))(?::[0-9]{1,5})?(?:\/[^\s]*)?/;
const EMAIL_REGEX = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
const MATCHERS = [
  createLinkMatcherWithRegExp(URL_REGEX, (text) => {
    return text.startsWith("http") ? text : `https://${text}`;
  }),
  createLinkMatcherWithRegExp(EMAIL_REGEX, (text) => {
    return `mailto:${text}`;
  })
];
const LexicalAutoLinkPlugin = () => {
  return /* @__PURE__ */ React__default.createElement(AutoLinkPlugin, { matchers: MATCHERS });
};
export {
  LexicalAutoLinkPlugin
};
